/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LeadingStockStockResponse = {
    code: string;
    name: string;
    level1: string;
    level2: string;
    level3: (string | null);
    pct_change: (number | null);
    ml_pct_change: (number | null);
    ml_pct_rank: (number | null);
    trend_state: LeadingStockStockResponse.trend_state;
    main_line: boolean;
    continuing_main_line: boolean;
    main_line_start_date: (string | null);
    main_line_days: (number | null);
    level1_rank: (number | null);
    level2_rank: (number | null);
    pct_9d: (number | null);
    pct_30d: (number | null);
    hit_supervision: boolean;
    hit_9d_supervision: boolean;
    break_9d_supervision: boolean;
    hit_30d_supervision: boolean;
    break_30d_supervision: boolean;
};
export namespace LeadingStockStockResponse {
    export enum trend_state {
        CANDIDATE = 'candidate',
        MAIN_LINE = 'main_line',
    }
}

